import { IUserProfile } from "services/apiTypes";

export type DashboardScopeType = "ALL_CENTERS" | "CURRENT_CENTER" | "NONE";

export interface DashboardScope {
  showMetrics: boolean;
  scope: DashboardScopeType;
  centerId?: number;
  roleName: string;
}

/**
 * Determina el alcance de visibilidad de métricas en el Dashboard según el usuario autenticado.
 *
 * Reglas por rol:
 *   - Supervisor (super_admin, admin, supervisor, regional): Ve métricas globales (ALL_CENTERS)
 *   - Director: Ve métricas exclusivamente de su centro asignado (CURRENT_CENTER)
 *   - Operador (operator): No consulta ni renderiza la sección de KPIs (NONE)
 */
export function getDashboardScope(user: IUserProfile | null | undefined): DashboardScope {
  if (!user || !user.role) {
    return {
      showMetrics: false,
      scope: "NONE",
      roleName: "Operador",
    };
  }

  const roleLower = user.role.toLowerCase();

  // Supervisor / Admin / Regional
  if (
    roleLower === "super_admin" ||
    roleLower === "admin" ||
    roleLower === "supervisor" ||
    roleLower === "regional"
  ) {
    return {
      showMetrics: true,
      scope: "ALL_CENTERS",
      roleName: user.role === "super_admin" ? "Super Admin" : user.role === "admin" ? "Administrador" : "Supervisor",
    };
  }

  // Director
  if (roleLower === "director") {
    return {
      showMetrics: true,
      scope: "CURRENT_CENTER",
      centerId: user.centerId ?? undefined,
      roleName: "Director de Centro",
    };
  }

  // Operador u otros
  return {
    showMetrics: false,
    scope: "NONE",
    roleName: "Operador",
  };
}
